import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackTemplateCompletedSpec,
  trackTemplateConvertedSpec,
  trackTemplateCreatedSpec,
  trackTemplateCreationRecordCreatedSpec,
  trackTemplateDeletedSpec,
  trackTemplateEditorUpdatedSpec,
  trackTemplateFailedSpec,
  trackTemplateGenerationSpec,
  trackTemplateOpenedSpec,
  trackTemplateQualityGateSpec,
  trackTemplateSearchedSpec,
  trackTemplateSelectedSpec,
  trackTemplateUpdatedSpec,
  trackTemplateViewedSpec,
  type TemplateCompleted,
  type TemplateConverted,
  type TemplateCreated,
  type TemplateCreationRecordCreated,
  type TemplateDeleted,
  type TemplateEditorUpdated,
  type TemplateFailed,
  type TemplateGeneration,
  type TemplateOpened,
  type TemplateQualityGate,
  type TemplateSearched,
  type TemplateSelected,
  type TemplateUpdated,
  type TemplateViewed,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const templateEvents: SnowplowEventMap = {
  [TrackingEventName.TemplateCreated]: (props) => {
    // The frontend prop is `src` (kept for Amplitude continuity); the Iglu
    // schema field is `source`. Remap here and drop `src` so the Snowplow
    // payload carries only the schema field.
    const { src, ...rest } = props as TemplateCreated & { src?: string };
    trackTemplateCreatedSpec({ ...rest, source: src ?? rest.source });
  },
  [TrackingEventName.TemplateUpdated]: (props) =>
    trackTemplateUpdatedSpec(props as TemplateUpdated),
  [TrackingEventName.TemplateEditorUpdated]: (props) =>
    trackTemplateEditorUpdatedSpec(props as TemplateEditorUpdated),
  [TrackingEventName.TemplateGeneration]: (props) =>
    trackTemplateGenerationSpec(props as TemplateGeneration),
  [TrackingEventName.TemplateCreationRecordCreated]: (props) =>
    trackTemplateCreationRecordCreatedSpec(props as TemplateCreationRecordCreated),
  [TrackingEventName.TemplateOpened]: (props) =>
    trackTemplateOpenedSpec(props as TemplateOpened),
  [TrackingEventName.TemplateSelected]: (props) =>
    trackTemplateSelectedSpec(props as TemplateSelected),
  [TrackingEventName.TemplateFailed]: (props) =>
    trackTemplateFailedSpec(props as TemplateFailed),
  [TrackingEventName.TemplateCompleted]: (props) =>
    trackTemplateCompletedSpec(props as TemplateCompleted),
  [TrackingEventName.TemplateViewed]: (props) =>
    trackTemplateViewedSpec(props as TemplateViewed),
  [TrackingEventName.TemplateDeleted]: (props) =>
    trackTemplateDeletedSpec(props as TemplateDeleted),
  [TrackingEventName.TemplateSearched]: (props) =>
    trackTemplateSearchedSpec(props as TemplateSearched),
  // Without either entry below the event reaches Datadog only and is dropped
  // silently in prod, while every "track was called" unit test still passes.
  [TrackingEventName.TemplateQualityGate]: (props) =>
    trackTemplateQualityGateSpec(props as TemplateQualityGate),
  [TrackingEventName.TemplateConverted]: (props) =>
    trackTemplateConvertedSpec(props as TemplateConverted),
};
